<template>
	<section class="form-room-container">
		<v-form v-on:submit.prevent="saveForm">
			<v-layout wrap row>
				<v-flex md8 body-border-right>
					<div class="body-border-bottom mb-3">
						<v-layout class="form-section" row wrap>
							<v-flex md12>
								<div class="label-section">
									<p>Detalles de la habitacion</p>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<v-select
										v-bind:items="subsidiaries"
										v-model="model.com_subsidiaries_id"
										label="Sucursal"
										item-text="name"
										item-value="id"
										single-line
										v-on:change="loadBuildings"
										hide-details></v-select>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<v-select
										v-bind:items="buildings"
										v-model="model.building_id"
										v-bind:disabled="buildings.length === 0"
										label="Edificio"
										item-text="name"
										item-value="id"
										single-line
										hide-details></v-select>
								</div>
							</v-flex>
						</v-layout>
						<v-layout class="form-section" row wrap>
							<v-flex md4>
								<div class="label-section">
									<label>Tipo de habitacion</label>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="label-section">
									<label for="name">Nombre de habitacion</label>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="label-section">
									<label for="quantity">Cantidad</label>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<v-select v-bind:items="categories" v-model="model.flagroom" label="Habitacion"
									  single-line bottom hide-details></v-select>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<input id="name" name="name" type="text" v-model="model.name" class="input-form"
									/>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<input id="quantity" name="quantity" type="text" v-model="model.quantity"
									  class="input-form" />
								</div>
							</v-flex>
						</v-layout>
						<v-layout class="form-section" row wrap>
							<v-flex md4>
								<div class="label-section">
									<label for="color">Color Picker</label>
								</div>
							</v-flex>
							<v-flex md8>
								<div class="label-section">
									<label for="code">Codigo de la habitacion</label>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control">
									<div class="color-picker">
										<v-menu v-model="showColorPicker" offset-x v-bind:close-on-content-click="false"
										  v-bind:top="true" v-bind:full-width="true">
											<div slot="activator">
												<input id="color" name="color" type="text" class="input-form" v-model="model.color"
												/>
												<div class="current-color" v-bind:style="currentPicker">
												</div>
											</div>
											<v-list class="menu-color-picker">
												<button type="button" class="btn-danger" v-on:click="showColorPicker = false">Cerrar</button>
												<chrome-picker v-bind:value="colors" v-on:input="onUpdateColor" />
											</v-list>
										</v-menu>
									</div>
								</div>
							</v-flex>
							<v-flex md4>
								<div class="control text-xs-left">
									<input
										id="code"
										name="code"
										type="text"
										maxlength="3"
										v-on:keyup="textToUpperCase(model.code_roomtype)"
										class="input-form"
										v-model="model.code_roomtype"
									/>
									<span class="helper">Máximo 3 caracteres</span>
								</div>
							</v-flex>
						</v-layout>
					</div>
				</v-flex>
				<v-flex md4>
					<v-layout row wrap>
						<v-flex md12>
							<div class="label-section">
								<label for="manual">Manual de la habitacion</label>
							</div>
						</v-flex>
						<v-flex class="mb-3" md12>
							<div class="control full">
								<input id="manual" name="manual" type="text" class="input-form" v-model="model.manual_title"
								/>
							</div>
						</v-flex>
						<v-flex md12>
							<file-upload-container class="mb-3" label-for="manual-url" v-on:upload="onUploadImage"
							  v-bind:allowed-files="['PDF']" v-bind:image-url="model.manual_url"
							  v-bind:disable-validation="true" v-bind:preview-image="false" />
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md12>
					<v-layout wrap row>
						<v-flex md2>
							<v-btn type="submit" class="save-btn">
								Guardar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-form>
	</section>
</template>

<script>

import { Chrome } from 'vue-color';
import helper from '@/shared/helper';
import mixins from '@/shared/mixins';
import TasksList from '@/components/shared/TasksList';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

const DEFAULT_COLOR = '#7448Ca';
const helperData = helper.data();

const defaultProps = {
	hex: DEFAULT_COLOR,
	hsl: {
		h: 150,
		s: 0.5,
		l: 0.2,
		a: 1,
	},
	hsv: {
		h: 150,
		s: 0.66,
		v: 0.30,
		a: 1,
	},
	rgba: {
		r: 25,
		g: 77,
		b: 51,
		a: 1,
	},
	a: 1,
};

function created() {
	this.loadSubsidiaries();
	if (this.id) {
		this.loadData();
	}
}

async function loadBuildings(id) {
	const filterGroups = [{
		filters: [{
			key: 'com_subsidiaries_id',
			value: id,
			operator: 'eq',
		}],
	}];
	const response = await this.$http.get('building-simple-list', { params: { filter_groups: filterGroups } });
	this.buildings = response.data;
}

async function loadData() {
	const filterGroups = [];
	const response = await this.$http.get(`roomtype/${this.id}`);
	filterGroups.push(this.renderFilter('com_subsidiaries_id', response.data.com_subsidiaries_id, 'eq'));
	const buildingsResponse = await this.$http.get('building-simple-list', { params: { filter_groups: filterGroups } });
	this.buildings = buildingsResponse.data;
	this.model = response.data;
}

function currentPicker() {
	return `background-color: ${this.model.color}`;
}

function data() {
	return {
		buildings: [],
		categories: [{ value: 1, text: 'Habitaciones' }, { value: 2, text: 'Otros Ambientes' }],
		colors: defaultProps,
		model: {
			building_id: 0,
			code_roomtype: '',
			color: DEFAULT_COLOR,
			flagroom: 1,
			manual_title: 'Titulo',
			manual_url: helperData.preimageUrl,
			name: 'Executive Suite Queen',
			quantity: 1,
			roomTypeId: 0,
			com_subsidiaries_id: 0,
			tasks: [],
		},
		quantities: [],
		showColorPicker: false,
	};
}

function onUpdateColor({ hex }) {
	this.model.color = hex;
}

function onUploadImage(url) {
	this.model.manual_url = url;
}

async function saveForm() {
	const method = this.id ? 'put' : 'post';
	const url = this.id ? `roomtype/${this.id}` : 'roomtype';
	if (this.model.com_subsidiaries_id > 0 && this.model.building_id > 0) {
		try {
			await this.$http[method](url, this.model);
			this.$router.push({ name: 'rooms' });
		} catch (error) {
			this.showNotification('Room type cannot be created', 'error');
		}
	} else {
		this.showNotification('Es necesario elegir Sucursal y Edificio para crear un tipo de habitación', 'error');
	}
}

function textToUpperCase(value) {
	this.model.code_roomtype = value.toUpperCase();
}

export default {
	name: 'create-room',
	components: {
		'chrome-picker': Chrome,
		FileUploadContainer,
		TasksList,
	},
	computed: {
		currentPicker,
	},
	created,
	data,
	methods: {
		loadBuildings,
		loadData,
		onUpdateColor,
		onUploadImage,
		saveForm,
		textToUpperCase,
	},
	mixins,
	props: ['id'],
};
</script>

<style lang="scss" scoped>
.form-room-container {
	p {
		font-family: map-get($fonts, medium);
		font-weight: 500;
		color: map-get($colors, dark);
		text-align: left;
	}

	textarea {
		height: 166px;
	}

	span {
		&.icon {
			color: white;
			font-size: 35px;
			height: 35px;
			margin: -7px 6px 0 0;
		}
	}

	.btn {
		color: white !important;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		height: 40px;
		width: 114px;

		&.add {
			background-color: map-get($colors, button-create);
		}
	}

	.color-picker {
		position: relative;
	}

	.current-color {
		height: 24px;
		position: absolute;
		right: 8px;
		top: 8px;
		width: 24px;
	}

	.label-section {
		text-align: left;
	}

	.control {
		&.full {
			width: 100%;
		}
	}

	.form-section {
		margin-bottom: 22px !important;
	}

	.left-section {
		border-right: 1px solid map-get($colors, e-bg-icon);
	}

	.right-section {
		padding: 0 19px 0 20px;
	}
}

.helper {
	font-size: map-get($sizes, twelve);
}
</style>




// WEBPACK FOOTER //
// FormRoom.vue?2cfeadab